import { render, staticRenderFns } from "./SecureTransaction.vue?vue&type=template&id=1ab3a759&scoped=true&"
import script from "./SecureTransaction.vue?vue&type=script&lang=js&"
export * from "./SecureTransaction.vue?vue&type=script&lang=js&"
import style0 from "./SecureTransaction.vue?vue&type=style&index=0&id=1ab3a759&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab3a759",
  null
  
)

export default component.exports